/* Transitional protection around the legacy app; pricing and cart payloads stay native. */
(function () {
  'use strict';
  if (window.__avLegacyCartGuard) return;
  var app = Array.from(document.scripts).find(function (script) {
    return /\/fetch-test-app-88\/assets\/app-(pipe|plate|onlylength)\.js(?:\?|$)/.test(script.src);
  });
  if (!app || !['sendConfig', 'waitForVariantPrice', 'waitForStorefrontPrice'].every(function (name) { return typeof window[name] === 'function'; })) return;
  window.__avLegacyCartGuard = true;
  var active = null;
  var english = document.documentElement.lang.toLowerCase().indexOf('en') === 0;
  var messages = english ? {
    busy: 'Your cut is being prepared. Please wait.',
    failed: 'Your cut could not be added. Please check the configuration and try again.',
    uncertain: 'The cart could not be confirmed. Please check your cart before trying again.',
    added: 'Added to your cart.',
    cart: 'Check cart'
  } : {
    busy: 'Dein Zuschnitt wird vorbereitet. Bitte einen Moment warten.',
    failed: 'Dein Zuschnitt konnte nicht hinzugef\u00fcgt werden. Bitte Konfiguration pr\u00fcfen und erneut versuchen.',
    uncertain: 'Der Warenkorb konnte nicht best\u00e4tigt werden. Bitte pr\u00fcfe ihn vor einem erneuten Versuch.',
    added: 'Zum Warenkorb hinzugef\u00fcgt.',
    cart: 'Warenkorb pr\u00fcfen'
  };
  var controls = '.pk-container input, .pk-container select, .pk-container button, .pklist-row input, .pklist-row select, .pklist-row button';
  var submit = '.pk-container .product-form__submit, .pklist-row .product-form__submit';
  var nativeFetch = window.fetch;
  var productHandle = window.location.pathname.match(/\/products\/([^/]+)/);

  function readRequestValue(data, key) {
    if (!data) return null;
    if (typeof data.get === 'function') {
      var direct = data.get(key);
      if (direct != null) return direct;
      if (key === 'id') return data.get('items[0][id]');
      return null;
    }
    if (typeof data === 'object') {
      if (data[key] != null) return data[key];
      if (key === 'id' && Array.isArray(data.items) && data.items[0]) {
        return data.items[0].id != null ? data.items[0].id : data.items[0].variant_id;
      }
      return null;
    }
    if (typeof data !== 'string') return null;
    try {
      var params = new URLSearchParams(data);
      var value = params.get(key);
      if (value == null && key === 'id') value = params.get('items[0][id]');
      if (value != null) return value;
    } catch (_) {}
    try { return readRequestValue(JSON.parse(data), key); } catch (_) { return null; }
  }

  function findListButton(args) {
    for (var index = args.length - 1; index >= 0; index -= 1) {
      var candidate = args[index];
      if (candidate === null || candidate === undefined || (typeof candidate !== 'string' && typeof candidate !== 'number')) continue;
      var button = document.getElementById(String(candidate));
      if (button && button.matches && button.matches('.pklist-row .product-form__submit')) return button;
    }
    var focused = document.activeElement;
    return focused && focused.closest ? focused.closest('.pklist-row .product-form__submit') : null;
  }

  function localUrl(url) {
    try {
      var parsed = new URL(typeof url === 'string' ? url : url.url, window.location.href);
      return parsed.origin === window.location.origin ? parsed : null;
    } catch (_) { return null; }
  }

  function isCartAddUrl(url) {
    return /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?cart\/add(?:\.js)?$/.test(url.pathname);
  }

  function markCartAdded(job, data, expected) {
    if (job.finished) return;
    var items = data && Array.isArray(data.items) ? data.items : [data];
    var expectedNumber = expected == null || expected === '' ? null : Number(expected);
    job.added = items.some(function (item) {
      if (!item || Number(item.quantity) <= 0) return false;
      var itemId = item.variant_id != null ? item.variant_id : item.id;
      var matchesId = expectedNumber == null || Number(itemId) === expectedNumber;
      var price = item.price == null ? null : Number(item.price);
      return matchesId && (price == null || Number.isFinite(price) && price !== 99999);
    });
    if (!job.added) { finish(job, 'uncertain'); return; }
    job.fallback = setTimeout(function () { finish(job, 'added'); }, 1500);
  }

  function show(job, state) {
    if (!job.notice) {
      job.notice = document.createElement('div');
      job.notice.setAttribute('data-av-cart-status', '');
      job.notice.setAttribute('role', 'status');
      job.notice.setAttribute('aria-live', 'polite');
      job.text = document.createElement('span');
      job.link = document.createElement('a');
      job.link.href = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart';
      job.link.textContent = messages.cart;
      job.link.style.cssText = 'display:block;margin-top:4px;text-decoration:underline';
      job.notice.append(job.text, job.link);
      var listCell = job.button.closest && job.button.closest('.pklist-row') ? job.button.parentElement : null;
      if (listCell) {
        if (getComputedStyle(listCell).position === 'static') listCell.style.position = 'relative';
        job.notice.style.cssText = 'position:absolute;left:0;right:0;top:calc(100% + 8px);z-index:5;box-sizing:border-box;padding:10px 12px;line-height:1.5;background:#fff;border:1px solid #d1d5db;box-shadow:0 4px 12px rgba(15,23,42,.12)';
        listCell.appendChild(job.notice);
      } else {
        job.notice.style.cssText = 'padding:10px 0;line-height:1.5';
        job.button.insertAdjacentElement('afterend', job.notice);
      }
    }
    job.notice.dataset.state = state;
    job.text.textContent = messages[state];
    job.button.setAttribute('aria-busy', String(state === 'busy'));
  }

  function lock(job) {
    job.locked = new Map();
    document.querySelectorAll(controls).forEach(function (element) {
      job.locked.set(element, element.disabled);
      element.disabled = true;
    });
    show(job, 'busy');
  }

  function finish(job, state) {
    if (job.finished) return;
    job.finished = true;
    clearTimeout(job.deadline);
    clearTimeout(job.fallback);
    clearTimeout(job.startCheck);
    job.controllers.forEach(function (controller) { controller.abort(); });
    job.locked.forEach(function (disabled, element) { element.disabled = disabled; });
    document.querySelectorAll(submit).forEach(function (button) {
      button.classList.remove('action-button--loading');
      button.removeAttribute('aria-busy');
      if (state === 'uncertain') button.disabled = true;
    });
    show(job, state);
    if (state !== 'uncertain' && active === job) active = null;
  }

  // A lost write response must never trigger an automatic second add-to-cart.
  function cancel(job) {
    if (job.finished) return;
    job.cancelled = true;
    job.stop(new Error('Legacy configurator deadline'));
    if (job.xhr) job.xhr.abort();
    finish(job, 'uncertain');
  }

  if (typeof nativeFetch === 'function') {
    window.fetch = function (input, options) {
      var job = active;
      var url = localUrl(input);
      var normalizedInput = input;
      if (job && url && productHandle && url.pathname === '/products/' + productHandle[1]) {
        var brokenHash = url.hash.replace(/^#/, '');
        var hashQueryIndex = brokenHash.indexOf('?');
        var hashPath = hashQueryIndex === -1 ? brokenHash : brokenHash.slice(0, hashQueryIndex);
        if (/\.js$/.test(hashPath)) {
          var normalizedUrl = new URL(url.href);
          normalizedUrl.pathname += '.js';
          normalizedUrl.search = hashQueryIndex === -1 ? url.search : brokenHash.slice(hashQueryIndex + 1);
          normalizedUrl.hash = '';
          normalizedInput = normalizedUrl;
          url = normalizedUrl;
        }
      }
      var cartAdd = url && isCartAddUrl(url);
      var legacy = url && (/^\/apps\/aluverkauf-produktkonfigurator\/(receive-data-(pipe|plate|onlylength)|checkvariant)$/.test(url.pathname) || productHandle && url.pathname.endsWith('/products/' + productHandle[1] + '.js'));
      if (!job || !url || (!cartAdd && !legacy)) {
        return nativeFetch.apply(this, arguments);
      }
      if (job.cancelled || job.finished) return Promise.reject(new Error('Legacy configurator stopped'));
      if (cartAdd) {
        var requestedVariantId = readRequestValue(options && options.body, 'id');
        job.variantId = requestedVariantId || job.variantId;
        job.addStarted = true;
        return nativeFetch.apply(this, arguments).then(function (response) {
          if (!response.ok) {
            finish(job, 'uncertain');
            return response;
          }
          var clone = response.clone ? response.clone() : null;
          if (!clone || typeof clone.json !== 'function') {
            finish(job, 'added');
            return response;
          }
          clone.json().then(function (data) {
            markCartAdded(job, data, job.variantId);
          }, function () {
            finish(job, 'uncertain');
          });
          return response;
        }, function (error) {
          finish(job, 'uncertain');
          throw error;
        });
      }
      var controller = new AbortController();
      job.controllers.push(controller);
      var settings = Object.assign({}, options, { signal: controller.signal });
      if (options && options.signal) {
        if (options.signal.aborted) controller.abort();
        else options.signal.addEventListener('abort', function () { controller.abort(); }, { once: true });
      }
      return Promise.race([nativeFetch.call(this, normalizedInput, settings), job.stopped]).then(function (response) {
        if (!response.ok) throw new Error('Legacy configurator HTTP ' + response.status);
        ['text', 'json'].forEach(function (method) {
          var read = response[method].bind(response);
          response[method] = function () { return Promise.race([read(), job.stopped]); };
        });
        return response;
      });
    };
  }

  var instances = [window.jQuery, window.$inputLength && window.$inputLength.constructor];
  instances.filter(function (jq, index) { return jq && typeof jq.ajaxPrefilter === 'function' && instances.indexOf(jq) === index; }).forEach(function (jq) {
    jq.ajaxPrefilter(function (options, original, xhr) {
      var job = active;
      var url = localUrl(options.url);
      var requestedVariantId = readRequestValue(original.data, 'id');
      if (!job || !url || !isCartAddUrl(url) || job.variantId != null && requestedVariantId != null && Number(requestedVariantId) !== Number(job.variantId)) return;
      if (job.cancelled || job.finished) { xhr.abort(); return; }
      options.dataTypes = ['json'];
      options.dataType = 'json';
      options.contents = Object.assign({}, options.contents, { script: false });
      options.timeout = 15000;
      job.xhr = xhr;
      job.addStarted = true;
      xhr.done(function (data) {
        job.variantId = requestedVariantId || job.variantId;
        markCartAdded(job, data, job.variantId);
      });
      xhr.fail(function () { finish(job, 'uncertain'); });
    });
  });

  var nativePriceGate = window.waitForVariantPrice;
  window.waitForVariantPrice = function (id) {
    if (active && !active.finished) active.variantId = id;
    return nativePriceGate.apply(this, arguments);
  };

  ['sendConfig', 'sendConfigFromList'].forEach(function (name) {
    var original = window[name];
    if (typeof original !== 'function') return;
    window[name] = function () {
      if (active) return active.result;
      var args = arguments;
      var button = name === 'sendConfigFromList'
        ? findListButton(args)
        : document.querySelector('.pk-container .product-form__submit');
      if (!button || button.disabled) return;
      document.querySelectorAll('[data-av-cart-status]').forEach(function (notice) { notice.remove(); });
      var job = { button: button, controllers: [], added: false, finished: false, cancelled: false };
      job.stopped = new Promise(function (_, reject) { job.stop = reject; });
      job.stopped.catch(function () {});
      active = job;
      lock(job);
      job.deadline = setTimeout(function () { cancel(job); }, 60000);
      try { job.result = original.apply(this, args); }
      catch (_) { finish(job, 'failed'); return; }
      Promise.resolve(job.result).then(function () {
        if (!job.addStarted) {
          job.startCheck = setTimeout(function () {
            if (!job.finished && !job.addStarted) finish(job, 'failed');
          }, 5000);
        }
      }, function () {
        finish(job, job.addStarted ? 'uncertain' : 'failed');
      });
      return job.result;
    };
  });

  document.addEventListener('cart:open', function () {
    if (active && active.added && !active.finished) finish(active, 'added');
  });
  document.addEventListener('click', function (event) {
    if (active && event.target.closest && event.target.closest(submit + ', .pk-container .input-number-increment, .pk-container .input-number-decrement, .pklist-row .input-number-increment, .pklist-row .input-number-decrement')) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
})();
